import React, { useContext, useEffect, useState } from 'react'
import PageTitle from '../../../Components/PageTitle'
import { ConfigContext } from '../../../Context/ConfigContext'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import { DateFormater } from '../../../Components/GLobal'
import Swal from 'sweetalert2'

const ExamDetails = () => {
    const { student_subject_id } = useParams();
    const navigate = useNavigate();

    const [isDisable, setIsDisable] = useState(false);
    const { apiURL, apiHeaderJson, primaryColor } = useContext(ConfigContext);
    const headers = apiHeaderJson;

    const [info, setInfo] = useState({});
    const [loading, setLoading] = useState(true);
    const [isExamDay, setIsExamDay] = useState(false);

    const GetInfo = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${apiURL}Students/GetExamInfo`, {
                params: { student_subject_id },
                headers
            });

            if (response?.data?.success) {
                setInfo(response.data.data);
                checkExamDay(response.data.data.exam_date);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    const checkExamDay = (examDate) => {
        if (!examDate) return;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const exam = new Date(examDate);
        exam.setHours(0, 0, 0, 0);

        const expiryDate = new Date(exam);
        expiryDate.setDate(expiryDate.getDate() + 5);

        setIsExamDay(today >= exam && today < expiryDate);
    }

    useEffect(() => {
        GetInfo();
    }, [student_subject_id])

    const getExamStatus = () => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const examDate = new Date(info.exam_date);
        examDate.setHours(0, 0, 0, 0);

        const expiryDate = new Date(examDate);
        expiryDate.setDate(expiryDate.getDate() + 5);

        if (today >= expiryDate) {
            return { text: 'Expired', color: 'secondary', badge: 'bg-secondary' };
        }

        const diff = Math.ceil((examDate - today) / (1000 * 60 * 60 * 24));

        if (diff === 0) return { text: 'Today', color: 'danger', badge: 'bg-danger' };
        if (diff === 1) return { text: 'Tomorrow', color: 'warning', badge: 'bg-warning' };
        if (diff > 1 && diff <= 7) return { text: `${diff} Days Left`, color: 'info', badge: 'bg-info' };

        return { text: 'Upcoming', color: 'secondary', badge: 'bg-secondary' };
    };

    const examStatus = getExamStatus();

    const handleStartExam = async () => {
        try {
            setIsDisable(true);
            const body = {
                student_id: info?.student_id,
                student_subject_id: info?.student_subject_id,
                student_program_id: info?.student_program_id,
                master_subject_id: info?.master_subject_id,
            }

            const response = await axios.post(`${apiURL}Students/StartExam`, body, { headers });

            if (response?.data?.success) {

                Swal.fire({
                    icon: response.data.action === "RESUME" ? "info" : "success",
                    title: response.data.action === "RESUME"
                        ? "Resume Exam"
                        : "Exam Started",
                    text: response.data.message
                }).then(() => {
                    navigate(`/Student/StartExam/${info?.student_subject_id}`)
                });
            }

        } catch (error) {
            console.log(error);
        } finally {
            setIsDisable(false);
        }
    }

    if (loading) {
        return (
            <div className='main-content'>
                <div className='page-content'>
                    <div className='container-fluid'>
                        <br />
                        <PageTitle title={"Exam Details"} primary={"Dashboard"} />
                        <div className="text-center my-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="mt-2">Loading exam details...</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className='main-content'>
            <div className='page-content'>
                <div className='container-fluid'>
                    <br />
                    <PageTitle title={"Exam Details"} primary={"Dashboard"} />

                    <div className="row">
                        {/* Main Exam Information Card */}
                        <div className="col-lg-8">
                            <div className="card shadow-sm">
                                <div className="card-header" style={{ background: primaryColor }}>
                                    <h5 className="card-title mb-0 text-white">
                                        <i className="fas fa-file-alt me-2"></i>
                                        Exam Information
                                    </h5>
                                </div>
                                <div className="card-body">

                                    {/* Student Info */}
                                    <div className="d-flex align-items-center mb-4 pb-3 border-bottom">
                                        <img
                                            src={
                                                info?.student_photo_url ||
                                                "https://ui-avatars.com/api/?name=Student&background=0D6EFD&color=fff"
                                            }
                                            alt={info?.student_full_name}
                                            className="rounded-circle border shadow-sm"
                                            style={{
                                                width: "80px",
                                                height: "80px",
                                                objectFit: "cover"
                                            }}
                                        />

                                        <div className="ms-3">
                                            <h4 className="mb-1 fw-bold">
                                                {info?.student_full_name || "-"}
                                            </h4>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label fw-semibold text-muted">
                                                    Subject Name
                                                </label>
                                                <p className="fs-5 fw-bold text-dark">
                                                    {info.subject_title}
                                                </p>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label fw-semibold text-muted">
                                                    Subject Code
                                                </label>
                                                <p
                                                    className="fs-5 fw-bold"
                                                    style={{ color: primaryColor }}
                                                >
                                                    {info.subject_code}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label fw-semibold text-muted">
                                                    Program
                                                </label>
                                                <p className="fs-6 fw-bold text-dark">
                                                    {info.program_title} ({info.program_short_title})
                                                </p>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label fw-semibold text-muted">
                                                    Program Duration
                                                </label>
                                                <p className="fs-6 fw-bold text-dark">
                                                    {info.program_duration} Days
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            {/* Exam Description Card */}
                            {info.subject_long_description && (
                                <div className="card shadow-sm mt-4">
                                    <div className="card-header bg-light">
                                        <h5 className="card-title mb-0">
                                            <i className="fas fa-info-circle me-2"></i>
                                            Subject Description
                                        </h5>
                                    </div>
                                    <div className="card-body">
                                        <p className="text-muted mb-0">
                                            {info.subject_long_description || info.subject_short_description || 'No description available.'}
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Exam Status & Actions Card */}
                        <div className="col-lg-4">
                            <div className="card shadow-sm">
                                <div className="card-header" style={{ background: primaryColor }}>
                                    <h5 className="card-title mb-0 text-white">
                                        <i className="fas fa-calendar-check me-2"></i>
                                        Exam Status
                                    </h5>
                                </div>
                                <div className="card-body text-center">
                                    <div className={`badge ${examStatus.badge} fs-6 px-3 py-2 mb-3`}>
                                        {examStatus.text}
                                    </div>

                                    <div className="mb-4">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <span className="text-muted">Exam Date:</span>
                                            <strong className="fs-6">{DateFormater(info.exam_date)}</strong>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <span className="text-muted">Duration:</span>
                                            <strong className="fs-6">{info.exam_duration || '30'} minutes</strong>
                                        </div>
                                    </div>

                                    <div className="d-grid gap-2">
                                        {isExamDay ? (
                                            <button
                                                className="btn btn-success"
                                                onClick={handleStartExam}
                                                disabled={isDisable}
                                            >
                                                <i className={`fas ${info?.has_exam_started ? "fa-redo" : "fa-play"} me-2`}></i>
                                                {info?.has_exam_started ? "Resume Exam" : "Start Exam"}
                                            </button>
                                        ) : (
                                            <button className="btn btn-primary" disabled>
                                                <i className="fas fa-clock me-2"></i>
                                                {examStatus.text === 'Completed' ? 'Exam Completed' : 'Exam Not Started'}
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ExamDetails